import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BasketTicketItem } from 'src/app/models/(basket)/Basket.model';
import { SubTicket } from 'src/app/models/(item)/ticket/SubTicket.model';
import { Ticket } from 'src/app/models/(item)/ticket/Ticket.model';
import { ApiService } from 'src/app/services/core/api.service';

import { TicketService } from '../../../../services/app/ticket.service';
import { AppService } from 'src/app/services/core/app.service';
import { Subject, takeUntil } from 'rxjs';
import { ToastrServiceCore } from 'src/app/services/core/toastr.service';
import { ConfigService } from 'src/app/initializer/config.service';

@Component({
  selector: 'ticket-item2',
  templateUrl: './ticket-item2.component.html',
  styleUrls: ['./ticket-item2.component.css'],
})
export class TicketItem2Component implements OnInit {
  ENTRANCETICKETDESIGN = 'default';
  @Input() ticket: Ticket;
  isShowUserPanel: boolean = false;
  isLoadNewTicket: boolean = false;
  isShowNewTicketError: boolean = false;

  isShowSelectTicketDate: boolean = false;
  // endDate: moment.Moment;
  ticketForm = new FormGroup({
    checkDate: new FormControl('', [Validators.required]),
    adultCount: new FormControl(0),
    childrenCount: new FormControl(0),
  });

  constructor(
    private toastrServiceCore: ToastrServiceCore,
    private apiService: ApiService,
    private ticketService: TicketService,
    public appService: AppService,
  ) {
    this.isShowSelectTicketDate =
      appService.settings$.value.ISSHOWSELECTTICKETDATE;
    this.ENTRANCETICKETDESIGN =
      this.appService.settings$.value.ENTRANCETICKETDESIGN;
  }

  ngOnInit() {
    this.ticketForm.patchValue({
      checkDate: moment().format('YYYY-MM-DD'),
    });
  }

  goster() {
    console.log(this.ticket);
  }
  isShowUserPanelFunc(type?: string) {
    if (type == 'leave') this.isShowUserPanel = false;
    else {
      this.isShowUserPanel = !this.isShowUserPanel;
    }
  }

  decrementCount(type: string) {
    if (this.ticketForm.get(type).value > 0)
      this.ticketForm.get(type).setValue(this.ticketForm.get(type).value - 1);
  }
  incrementCount(type: string) {
    this.ticketForm.get(type).setValue(this.ticketForm.get(type).value + 1);
  }

  addTicket() {
    let x = new Date().toUTCString();

    if (this.appService.settings$.value.CLOSE_SELL == 'true') {
      this.appService.closeSellDialog();
    } else if (
      !this.ticketForm.value.checkDate ||
      this.ticketForm.value.checkDate == ''
    ) {
      this.toastrServiceCore.error('Please choose a date.');
      this.ticketForm.patchValue({
        checkDate: moment().format('YYYY-MM-DD'),
      });
      return;
    } else if (
      moment(this.ticketForm.value.checkDate).isBefore(
        moment().format('YYYY-MM-DD'),
      )
    ) {
      this.toastrServiceCore.error('You cannot buy tickets for a past date.');
      this.ticketForm.patchValue({
        checkDate: moment().format('YYYY-MM-DD'),
      });
    } else if (
      this.ticketForm.value.adultCount + this.ticketForm.value.childrenCount >
      0
    ) {
      let totalPrice =
        (this.ticketForm.value.adultCount *
          this.ticket.SUBTICKETS?.ADULT?.PRICE || 0) +
        (this.ticketForm.value.childrenCount *
          this.ticket.SUBTICKETS?.CHILDREN?.PRICE || 0);
      let ticketTemp: BasketTicketItem = {
        ...this.ticket,
        BASKETDETAIL: {
          ADULTCOUNT: this.ticketForm.value.adultCount,
          CHILDRENCOUNT: this.ticketForm.value.childrenCount,
          TOTALPRICE: totalPrice,
          CHECKDATE: moment(this.ticketForm.value.checkDate).format(
            'YYYY-MM-DD',
          ),
          CREATEDATE: moment().format('YYYY-MM-DD'),
        },
      };
      this.ticketService.addTicket(ticketTemp);
      this.isShowUserPanelFunc();
      this.toastrServiceCore.success('The ticket was added to the cart.');

      if (this.isShowSelectTicketDate) {
        let infoMes = this.getFormatDate(ticketTemp.BASKETDETAIL.CHECKDATE);
        this.toastrServiceCore.info(
          'Tickets are only available on @@message day.',
          null,
          [
            {
              '@@message': infoMes,
            },
          ],
        );
      }
    } else {
      this.toastrServiceCore.error('At least 1 ticket must be selected.');
    }
  }

  getFormatDate(date) {
    return (
      moment(date).get('date') +
      ' ' +
      moment(date).locale(this.appService.language$.value).format('MMMM') +
      ' ' +
      moment(date).locale(this.appService.language$.value).format('dddd')
    );
  }
  async changeDate() {
    let endDate = moment(this.ticket.SUBTICKETS.ADULT.ENDDATE);
    let startDate = moment(this.ticket.SUBTICKETS.ADULT.STARTDATE);

    let checkDate = moment(this.ticketForm.value.checkDate);
    let endDif = endDate.diff(checkDate, 'days');
    let startDif = startDate.diff(checkDate, 'days');
    if (endDif < 0 || startDif > 0) {
      this.isLoadNewTicket = true;

      (await this.apiService.getData(checkDate.format('YYYY-MM-DD')))
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: SubTicket) => {
          if (data[0]?.[0].SUBTICKETNAME !== null) {
            let tickets = this.ticketService.mappingAfterGetData(data[0]);
            this.ticket = tickets.find(
              (x) => x.TICKETNAME == this.ticket.TICKETNAME,
            );
            endDate = moment(this.ticket.SUBTICKETS.ADULT.ENDDATE);
            this.isLoadNewTicket = false;
          } else {
            this.toastrServiceCore.error(
              'No tickets were found for the date you selected, please change the date.',
            );
            this.isShowNewTicketError = true;
          }
        });
    }
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
